import type { PropTransformMap } from '@gik/core/api/base/hooks/searchParamsTransform';
import { searchParamsTransform } from '@gik/core/api/base/hooks/searchParamsTransform';
import type { Options } from 'ky';

export function searchParamsTransformKyHook(map: PropTransformMap) {
  return function (_request, options: Options) {
    searchParamsTransform(options, map);
  };
}
